import axios from 'axios';

const api = axios.create({
  baseURL: '/api/v1',
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = String(error.config?.url || '');

    if (status === 401 && !url.includes('/auth/login')) {
      localStorage.removeItem('token');
      // Surface the reason before leaving the console so the interruption is
      // never mistaken for an unresponsive control.
      if (typeof window !== 'undefined') {
        window.dispatchEvent(
          new CustomEvent('bluenode:session-expired', {
            detail: 'Your session has expired. Please sign in again.',
          })
        );
        setTimeout(() => {
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
        }, 1200);
      }
    }
    return Promise.reject(error);
  }
);

export const errorMessage = (error, fallback = 'The operation could not be completed.') =>
  error?.response?.data?.detail || error?.message || fallback;

export default api;
